import last from 'lodash/last';
import { reportFilters, reportForms } from '@/constants/reports';
import { DEFAULT_REPORT_TYPE } from '@/components/Reports/Sidebar/CascaderReport/options';

/*
    Модель хранит в себе общие данные для каждого фильтра. Это:
    * reportType - тип отчета
    * reportFilterType - тип отображаемого фильтра (зависит от reportType)
*/

export const filterReportModel = {
    name: 'filterReport',
    state: {
        /*
            Выбранный тип отчета. По умолчанию определен как "Тех режим - Добывающие".
        */
        reportType: DEFAULT_REPORT_TYPE,
        /*
            Вид фильтра. По умолчанию - Базовый.
        */
        reportFilterType: reportFilters.BASE,
    },
    reducers: {
        setReportType(state, payload) {
            const { value, filterType } = payload;

            /*
                TODO: Обработать ситуацию при возможном пустом value
            */

            return { ...state, reportType: value, reportFilterType: filterType };
        },
    },
    effects: dispatch => ({
        setReportTypeEffect(payload) {
            const value = payload.map(({ value }) => value);
            const filterType = last(payload).filter ?? reportFilters.BASE;
            const formType = last(payload).filter ?? reportForms.BASE;

            dispatch.filterReport.setReportType({ value, filterType });
            dispatch.baseFilterReport.setReportTypeForm(formType);
        },
        async getFilterParams(_, rootState) {
            const { reportFilterType, reportType } = rootState.filterReport;

            /*
                Формируется путь до нужного отчета из выбранного reportType в фильтре.
            */
            const reportTypePath = formatReportType(reportType);

            switch (reportFilterType) {
                case reportFilters.BASE:
                    return dispatch.baseFilterReport.getFilterParams(reportTypePath);
                case reportFilters.GDI:
                    return dispatch.gdiFilterReport.getFilterParams(reportTypePath);
                case reportFilters.GOSPLAN:
                    return dispatch.gosplanFilterReport.getFilterParams(reportTypePath);
                case reportFilters.MER:
                    return dispatch.merFilterReport.getFilterParams(reportTypePath);
                case reportFilters.TECH_INFO:
                    return { reportType: reportTypePath };
                case reportFilters.WELL_RESEARCH:
                    return { reportType: reportTypePath };
                case reportFilters.PLAN_ORDER:
                    return { reportType: reportTypePath };
                case reportFilters.EQUIPMENT_SELECTION:
                    return { reportType: reportTypePath };
                case reportFilters.KRS_AND_GTM:
                    return { reportType: reportTypePath };
                case reportFilters.REQUESTS_BLOCK:
                    return { reportType: reportType.join('/') };
                default:
                    return {};
            }
        },
    }),
};

/*
    Значение reportType представляет из себя массив значений, описывающий иерархию отношений (макс. 3 уровня);

    Например:

    ['TechMode', 'ProducingWells']: TechMode - 1 уровень, ProducingWells - 2 уровень;

    Часть ссылки, где используется ТИП отчета выглядит так: "/TechMode/TechMode_ProducingWells";

    ['TechMode', 'ProducingWells']: 1 элемент - это папка, конкатенация всех элементов массива - это название отчета;
*/
function formatReportType(array) {
    const folder = array[0];
    const name = array.join('_');

    return `${folder}/${name}`;
}
